import defaultTransition from './default'

export const Transitions = [
  defaultTransition,
]



//////////////////
// WEBPACK FOOTER
// ./scripts/barba/transitions/index.js
// module id = 21
// module chunks = 0